import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import { GenericErrorMessage } from '../GenericErrorMessage/index.js';
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            size: 'Large',
        };
    }
    static getDerivedStateFromError(error) {
        error['shouldIgnore'] = true;
        const _error = error.toString().split('Error: ')[1];
        window?.j360?.onError && window?.j360?.onError(error);
        return { error: _error };
    }
    render() {
        const { componentName, height = '100%', width = '100%', size = 'Large', direction = 'column', errorMessage = undefined, isStyled = false, showLogo = true, suppressMessage = false, } = this.props;
        const { error } = this.state;
        if (error) {
            if (this.props?.errorComponent) {
                const ErrorComponent = this.props.errorComponent;
                return _jsx(ErrorComponent, {});
            }
            return (_jsx(GenericErrorMessage, { showLogo: showLogo, suppressMessage: suppressMessage, errorMessage: errorMessage || `${componentName ? `${componentName}: ` : ''}${error}`, height: height, width: width, size: size, direction: direction, isStyled: isStyled, ...this.props }));
        }
        return _jsx(Fragment, { children: this.props.children });
    }
}
//# sourceMappingURL=ErrorBoundary.js.map